module.exports = __webpack_public_path__ + "media/img/pages/companies/epfl-0bdcac0c28c53d58dc04f66156794f45.png";